/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-10-16",
    versionChannel: "nightly",
    buildDate: "2024-10-16T00:06:12.075Z",
    commitHash: "ba191b3852562c2e7ca658973bcd8bbc8a89d497",
};
